import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InitializeService } from './services/initialize.service';
import { AuthService } from './services/Identity/Auth/auth.service';
import { InitializeTypeEnum } from '@smarttask-common/src/lib/models/Initialize/InitializeTypeEnum';
import { NavigationCancel, NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { CustomToastComponent } from './area/customToast/customToast';
import { installNestedDragAndDropPatch } from '@smarttask-common/src/lib/patch/nested-drag-and-drop-patch';
import { installDropdownPopoverZIndexPatch } from '@smarttask-common/src/lib/patch/dropdown-popover-z-index-patch';
import { installNgSelectPopoverZIndexPatch } from '@smarttask-common/src/lib/patch/ng-select-popover-z-index-patch';
import { DragDropModule } from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, DragDropModule],
})
export class AppComponent {
    private loader_subscription: Subscription;

    constructor(
        private initializeService: InitializeService,
        private authService: AuthService,
        private router: Router,
    ) {}

    ngOnInit() {
        this.watchIndexLoader();

        this.initializeService.result_promise
            .then((result) => {
                console.log(`Initialization Status - ${result}`);
                switch (result) {
                    case InitializeTypeEnum.new_user_success:
                        this.router.navigate(['/welcome']);
                        break;
                    case InitializeTypeEnum.success:
                        break;
                    case InitializeTypeEnum.auth_data_not_present:
                        //Only trigger authorizationCodeFlow if the url doesn't contain authorization
                        //as in that case the authorization code flow is ongoing
                        if (!location.href.includes('authorization')) {
                            this.authService.triggerAuthorizationFlow();
                        }
                        break;
                    default:
                        this.router.navigate(['/error']);
                        break;
                }
            })
            .catch((error) => {
                this.router.navigate(['/error']);
            });

        installNestedDragAndDropPatch();
        installDropdownPopoverZIndexPatch();
        installNgSelectPopoverZIndexPatch();
    }

    ngOnDestroy() {
        this.loader_subscription?.unsubscribe();
    }

    // The index.html loader sits outside <app-root>, so it stays visible while the initial
    // navigation resolves (homeResolver redirect, lazy organization chunk, route resolvers).
    // Remove it once a navigation has actually rendered, otherwise the screen is blank in between.
    private watchIndexLoader() {
        this.loader_subscription = this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError))
            .subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.hideIndexLoader();
                    return;
                }
                // A cancelled/failed navigation is usually superseded by a redirect (e.g. homeResolver).
                // Only hide if nothing else is in flight, so the loader can't get stuck on screen.
                setTimeout(() => {
                    if (!this.router.currentNavigation()) {
                        this.hideIndexLoader();
                    }
                });
            });
    }

    private hideIndexLoader() {
        this.loader_subscription?.unsubscribe();
        const loader = document.getElementById('st-index-loader');
        if (!loader) {
            return;
        }
        loader.classList.add('st-index-loader-hide');
        loader.addEventListener('transitionend', () => loader.remove(), { once: true });
        setTimeout(() => loader.remove(), 500); // Fallback if transitionend doesn't fire
    }
}
